// src/modules/restaurant/pages/respayment/hooks/useOrderDetails.ts
import { useEffect, useState } from "react";
import api from "src/features/auth/axiosConfig";
import { OrderList } from "../../../orders/types/orderTypes";

export const useOrderDetails = (id?: string) => {
  const [order, setOrder] = useState<OrderList | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    const fetchOrder = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/app/v1/pos/order/${id}`);
        setOrder(response.data.result || response.data);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch order details");
      } finally {
        setLoading(false);
      }
    };
    fetchOrder();
  }, [id]);

  return { order, setOrder, loading, error };
};
